import { useMemo } from 'react';
import { Addon } from '@g17eco/types/questionInterfaces';
import { UniversalTrackerPlain } from '@g17eco/types/universalTracker';
import { SmartMatchFieldHintContainer } from './SmartMatchFieldHintContainer';
import { useSmartMatchHints } from './useSmartMatchHints';

interface Params {
  utrvId?: string;
  utr?: Pick<UniversalTrackerPlain, 'valueType' | 'valueValidation' | 'numberScale' | 'unit'>;
}

export const useSmartMatchAddons = ({ utrvId, utr }: Params): Addon[] => {
  const hints = useSmartMatchHints(utrvId);

  return useMemo(() => {
    if (!utr || hints.length === 0) {
      return [];
    }

    // Collect unique codes: hints with valueListCode get per-field addons, hints without get a top-level addon
    const codes = new Set<string>();
    const hasTopLevel = hints.some((h) => !h.valueListCode);

    hints.forEach((hint) => {
      if (hint.valueListCode) {
        codes.add(hint.valueListCode);
      }
    });

    const addons: Addon[] = [];

    if (hasTopLevel) {
      addons.push({
        code: '',
        element: <SmartMatchFieldHintContainer key={utrvId} utr={utr} />,
      });
    }

    codes.forEach((code) => {
      addons.push({
        code,
        element: <SmartMatchFieldHintContainer key={`${utrvId}-${code}`} valueListCode={code} utr={utr} />,
      });
    });

    return addons;
  }, [hints, utr, utrvId]);
};
